import styled from "styled-components";

export const Container = styled.section`
  background-color: #3487d3;
  padding: 72px 40px;
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    padding: 56px 20px;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 56px;
  max-width: 1100px;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 40px;
    align-items: center;
  }
`;

/* Left side: image collage with form card overlaid */
export const LeftSide = styled.div`
  position: relative;
  flex: 0 0 520px;
  height: 560px;

  @media (max-width: 1024px) {
    flex: 0 0 440px;
    height: 500px;
  }

  @media (max-width: 900px) {
    flex: none;
    width: 100%;
    max-width: 500px;
    height: 460px;
  }
`;

export const ImageCollage = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

export const CollageImg = styled.img<{ pos: 'tl' | 'tr' | 'bl' | 'br' }>`
  position: absolute;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);

  ${({ pos }) => pos === 'tl' && `
    top: 0;
    left: 0;
    width: 50%;
    height: 48%;
  `}

  ${({ pos }) => pos === 'tr' && `
    top: -24px;
    right: 0;
    width: 46%;
    height: 58%;
  `}

  ${({ pos }) => pos === 'bl' && `
    bottom: 0;
    left: 4%;
    width: 44%;
    height: 50%;
  `}

  ${({ pos }) => pos === 'br' && `
    bottom: -20px;
    right: 2%;
    width: 48%;
    height: 44%;
  `}
`;

export const FormCard = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 20px;
  padding: 24px 24px;
  width: 268px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  z-index: 2;

  @media (max-width: 1024px) {
    width: 248px;
    padding: 20px 18px;
  }

  @media (max-width: 900px) {
    width: 288px;
  }
`;

export const FormTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #000000;
  margin: 0 0 2px 0;
`;

export const FormSubtitle = styled.p`
  font-family: 'Aileron', sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: #555555;
  margin: 0 0 12px 0;
  line-height: 1.4;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  margin-bottom: 6px;
`;

export const FieldFull = styled.div`
  margin-bottom: 6px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #dddddd;
  border-radius: 6px;
  font-family: 'Aileron', sans-serif;
  font-size: 11px;
  color: #333333;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #aaaaaa;
  }

  &:focus {
    border-color: #000000;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #dddddd;
  border-radius: 6px;
  font-family: 'Aileron', sans-serif;
  font-size: 11px;
  color: #333333;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  appearance: none;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #000000;
  }
`;

export const SubmitButton = styled.button`
  margin-top: 10px;
  width: 100%;
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 24px;
  padding: 10px 16px;
  font-family: 'Aileron', sans-serif;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.2s ease;

  &:hover {
    background-color: #222222;
  }

  &:disabled {
    background-color: #888888;
    cursor: not-allowed;
  }
`;

/* Right side: heading + body text */
export const RightSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 540px;
    text-align: center;
  }
`;

export const RightHeading = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 700;
  color: #f1f5c5;
  margin: 0 0 20px 0;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 26px;
  }

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const RightText = styled.p`
  font-family: 'Aileron', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  margin: 0;
  line-height: 1.65;
`;

export const SentMessage = styled.p`
  font-family: 'Aileron', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #2e7d32;
  text-align: center;
  margin-top: 10px;
`;
